module.exports = __webpack_public_path__ + "img/Pista_22.b8846649.png";